const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjUgNTEzIDM0MiI+CjxyZWN0IHk9Ijg1LjUiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSI1MTMiIGhlaWdodD0iMzQyIi8+CjxnIGZpbGw9IiMwMDdiMjMiPgoJPHJlY3QgeT0iODUuNSIgd2lkdGg9IjE3MSIgaGVpZ2h0PSIzNDIiLz4KCTxyZWN0IHg9IjM0MiIgeT0iODUuNSIgd2lkdGg9IjE3MSIgaGVpZ2h0PSIzNDIiLz4KPC9nPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=NG-59daa705.mjs.map
